import { faChevronDown, faChevronUp } from "@fortawesome/pro-solid-svg-icons";
import { Typography } from "@vapor/react-extended";
import {
  Autocomplete,
  Stack,
  Divider,
  IconButton,
  TextField,
} from "@vapor/react-material";
import { useTranslation } from "@onefront/react-sdk";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DocumentDatePicker from "../../../common-components/DocumentDatePicker";
import ChipsFilter from "../../../newDocuments/document-components/ChipsFilter";
import { useLocation } from "react-router-dom";
import { useGetAllowedMacrocategories } from "../../../newDocuments/hooks/api-hooks/useAllowedMacrocategories";
import { useClientInformationStore } from "../../../store/useClientInformationStore";
import { useDocumentList } from "../../state/useDocumentList";

const FiltersByCategory = ({
  handleFilterChange,
  filters,
  macroCategories,
  data,
}) => {
  const location = useLocation();

  const { documentFilterOption } = useDocumentList();

  const {
    selectedTenant: currentCompany,
    selectedWorkspace: ws,
    workspaceId,
    setWorkspaceId,
    tenantId,
  } = useClientInformationStore();

  const permisionData = useGetAllowedMacrocategories(workspaceId)?.data;

  return (
    <>
      {documentFilterOption !== "CESTINO" ? (
        <Stack
          direction="column"
          alignContent="space-between"
          justifyItems="center"
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <ChipsFilter
              handleFilterChange={handleFilterChange}
              filters={filters}
              macroCategories={macroCategories}
            />
          </Stack>
          <hr style={{ color: "#566B76", width: "100%" }} />
        </Stack>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default FiltersByCategory;
